module.exports = __webpack_public_path__ + "img/蓝色logo.05db0b77.png";